var map = {
	"./auto.svg": 2429,
	"./habitation.svg": 5841,
	"./lead.svg": 1180,
	"./orkpipo-svc-apim-portail.svg": 4059,
	"./sante.svg": 4131,
	"./verif-assure-auto.svg": 395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7762;